// extracted by mini-css-extract-plugin
export var author = "styles-module--author--POcXu";
export var blink = "styles-module--blink--AbzzB";
export var c_marquee = "styles-module--c_marquee--Rpnrg";
export var content = "styles-module--content--0KYhx";
export var text = "styles-module--text--JI9ux";